/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface NavHeaderUser {
  firstName: string;
  lastName: string;
  platformId: number;
  isTester?: boolean;
  isTTL?: boolean;
  isLite?: boolean;
  /**
   * Whether the user has selected a custom avatar (vs. the default silhouette).
   * Drives the header account button's accessible name so screen readers announce
   * what the avatar represents. Optional: adapters that can't cheaply resolve it
   * may leave it undefined, in which case the button keeps its plain label.
   */
  hasCustomAvatar?: boolean;
}

export interface NavHeaderMessages {
  count: number;
  hasUnread: boolean;
}

export interface NavHeaderAccountUrls {
  accountSettings: string;
  accountSecurity?: string;
  accountAdvanced: string;
}

export interface TesterNavigationHeaderService {
  getCurrentUser(): Promise<NavHeaderUser>;
  getUnreadMessages(): Promise<NavHeaderMessages>;
  getUnreadActivities(): Promise<NavHeaderMessages>;
  getChatUrl(): Promise<string | null>;
  getAccountUrls(): Promise<NavHeaderAccountUrls>;
  hasFeature(flag: string): boolean;
  logout(): void;
  avatarChanged$: Observable<void>;
}

export const TESTER_NAVIGATION_HEADER_SERVICE =
  new InjectionToken<TesterNavigationHeaderService>('TesterNavigationHeaderService');
